import Cookies from 'js-cookie';
import Device from '../helpers/Device';

export default class LanguageSwitcher {
  constructor() {
    this.COOKIE_LANG_KEY = 'lang';
    this.COOKIE_LANG_JP_VAL = 'jp';
    this.COOKIE_LANG_EN_VAL = 'en';

    this.currentLang = Cookies.get(this.COOKIE_LANG_KEY);

    if (Device.isMobile()) {
      this.$btn = $('.cmn-header .accordion-menu .lang');
    } else {
      this.$btn = $('.cmn-header .header-nav .lang');
    }

    this._addEvent();
  }

  /**
   * イベント登録.
   * @private
   */
  _addEvent() {
    this.$btn.on('click', (e) => {
      e.preventDefault();

      this._toggleCookieLangVal();
      location.href = '/';
    });
  }

  /**
   * Cookie['lang']の値をjp/enで切り替え.
   * @private
   */
  _toggleCookieLangVal() {
    if (this.currentLang === this.COOKIE_LANG_EN_VAL) {
      Cookies.set(this.COOKIE_LANG_KEY, this.COOKIE_LANG_JP_VAL);
    } else {
      Cookies.set(this.COOKIE_LANG_KEY, this.COOKIE_LANG_EN_VAL);
    }
  }
}
